export interface IWidgetInputFileTypes {
  pdf: string[];
  office: string[];
  text: string[];
  image: string[];
  [k: string]: string[];
}

// TODO-MID: completare lista tipi!
export const WidgetInputFileTypes: IWidgetInputFileTypes = {
  pdf: ['application/pdf'],
  office: [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // xlsx
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // docx
    'application/vnd.oasis.opendocument.text', // odt
    'application/vnd.oasis.opendocument.spreadsheet', // ods
    'application/vnd.ms-excel', // xls
    'application/msword', // doc
    'text/csv' // csv
  ],
  text: ['application/rtf', 'text/plain'],
  image: [
    'image/bmp',
    'image/gif',
    'image/vnd.microsoft.icon', // .ico
    'image/jpeg',
    'image/png',
    'image/svg+xml' // .svg
  ]
};
